@use "../../../../../styles/Colors.scss" as Colors;
@use "../../../../../styles/Constants.scss" as Constants;

.empty-time-sheet {
	padding-bottom: Constants.$val-headerHeight;
	background-color: Colors.$col-white;
	padding: Constants.$val-spacing-m;
	color: Colors.$col-grey;
	font-style: italic;
	font-size: Constants.$val-fontSizeRegular;
}
